"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var useIsSmallScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsSmallScreen"));
var Line_1 = __importDefault(require("@/frontend/react/components/Line"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var useIsMobileFullScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsMobileFullScreen"));
var ConnectionStyles_1 = require("@/frontend/react/connections/ConnectionStyles");
var ApplicationList_1 = __importDefault(require("./ApplicationList"));
var LocalApplicationContext_1 = require("./context/LocalApplicationContext");
var AppLayout_1 = require("../AppLayout");
var classes = {
    buttonGroup: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        marginBottom: 2,
        paddingTop: 4,
        paddingLeft: { xs: 3, md: 0 },
    },
    button: {
        color: 'black',
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '18px',
        '&.active': {
            color: 'primary.main',
            backgroundColor: 'white',
            borderRadius: '50px',
            padding: '0.5rem',
            border: '1px solid',
            borderColor: 'primary.main',
        },
    },
};
function ApplicationsPage() {
    var statusParam = (0, react_router_dom_1.useParams)().status;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var isMobileFullScreen = (0, useIsMobileFullScreen_1.default)();
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, sx: AppLayout_1.appLayoutClasses.container }, { children: (0, jsx_runtime_1.jsxs)(material_1.Container, __assign({ maxWidth: "lg", sx: { paddingLeft: { xs: 0, md: 3 }, paddingRight: { xs: 0, md: 3 } } }, { children: [isMobileFullScreen === false && ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.buttonGroup }, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: classes.button, component: react_router_dom_1.NavLink, to: "/applications/active" }, { children: trans_1.default.get('navs.frontend.application.active') })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: classes.button, component: react_router_dom_1.NavLink, to: "/applications/concept" }, { children: trans_1.default.get('navs.frontend.application.concept') })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: classes.button, component: react_router_dom_1.NavLink, to: "/applications/completed" }, { children: trans_1.default.get('navs.frontend.application.completed') }))] }))), isSmallScreen === false && (0, jsx_runtime_1.jsx)(Line_1.default, {}), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 4 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, display: isMobileFullScreen ? 'none' : 'block', sx: ConnectionStyles_1.containerStyles.titlePage }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h3", color: "secondary", fontWeight: "bold" }, { children: trans_1.default.get("navs.frontend.application.".concat(statusParam)) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 4, sx: { display: isMobileFullScreen ? 'none' : 'block', margin: { xs: 3, md: 0 } } }, { children: (0, jsx_runtime_1.jsx)(ApplicationList_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 8 }, { children: (0, jsx_runtime_1.jsx)(LocalApplicationContext_1.LocalApplicationProvider, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }) }))] }))] })) })));
}
exports.default = ApplicationsPage;
